import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';

export class FitnessBenefitMetadataExtension extends BenefitMetadataExtensionInterface {
  benefitId: BenefitDTOBenefitEnum = BenefitDTOBenefitEnum.Fitness;

  get Icon(): React.ComponentType<SvgIconProps> {
    return FitnessCenterIcon;
  }
}
